import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CatalogReferenceService } from '../../shared/services/catalog-reference.service';
import { CatContestsResponse } from '../../shared/interfaces/cat-contests-response.interface';

export const catContestsResolver: ResolveFn<CatContestsResponse[]> = () =>
  inject(CatalogReferenceService).getCatContests();
